{
  "aiCameraSettings": {
    "text": "5秒",
    "text2": "10秒",
    "text3": "30秒",
    "text4": "1分",
    "text5": "5分",
    "text6": "10分",
    "text7": "30分",
    "text8": "1時間",
    "text9": "3時間",
    "text10": "6時間",
    "text11": "1日",
    "text12": "{{days}}日",
    "text13": "{{hours}}時間",
    "text14": "{{minutes}}分",
    "text15": "{{normalized}}秒"
  },
  "aiDetectionUtils": {
    "text": "カスタム",
    "text2": "定型",
    "aiDetectionQuotaBlockedMessage": "検知量の上限に達し検知が停止しています。再開には翌月の更新、またはプラン変更が必要です。",
    "aiDetectionQuotaPartiallyBlockedMessage": "一部のカメラは検知量の上限に到達したため検知ができません",
    "text3": "移動済み",
    "text4": "停止済",
    "text5": "上限到達",
    "text6": "一部上限到達",
    "text7": "検知中",
    "text8": "人数",
    "text9": "ヘルメット",
    "text10": "侵入",
    "text11": "メーター",
    "text14": "人数: {{value}}",
    "text15": "値: {{value}}{{unit}}",
    "text16": "値: {{value}}",
    "text17": "継続中",
    "text18": "検知開始",
    "text19": "検知終了",
    "text20": "検知",
    "text21": "人数: {{personCount}}",
    "text22": "人数: {{result}}",
    "text23": "ヘルメット: {{helmet}}",
    "text24": "カスタム検知",
    "text25": "ヘルメット未着用",
    "text26": "以上",
    "text27": "超",
    "text28": "侵入検知エリア: {{roiId}}",
    "text29": "指定範囲への侵入を検知",
    "text30": "{{threshold}}人",
    "text31": "人物検知",
    "text32": "ヘルメット検知",
    "text33": "侵入検知",
    "text34": "定型検知",
    "text35": "{{cameraName}}（上限{{perCameraLimit}}件）",
    "text36": "{{categoryLabel}}の実行数がカメラの上限に達しています。上限に達しているカメラ: {{value}}",
    "aiDetectionLimitExceededMessage": "このカメラで実行できる検知数の上限に達しています。不要な検知を停止してから追加してください。",
    "text37": "{{areaName}}・すべてのカメラ",
    "text38": "すべてのカメラ",
    "text39": "{{areaName}}・{{targetCount}}台",
    "text40": "{{areaName}}のすべてのカメラ",
    "text41": "{{areaName}}の{{targetCount}}台",
    "text42": "{{targetCount}}台",
    "text43": "{{value}}検知",
    "text44": "オン",
    "text45": "初回検知時のみ通知",
    "text46": "1時間ごとに通知",
    "text47": "毎日 {{deliveryTime}} に通知",
    "text48": "1日1回通知",
    "text49": "{{start}} ~ 終了日なし",
    "text50": "終日",
    "text51": "5秒",
    "text52": "{{seconds}}秒",
    "text53": "{{value}}分",
    "text54": "{{value}}時間",
    "text55": "1日1回",
    "label": "対象カメラ",
    "label2": "通知設定",
    "label3": "通知タイミング",
    "label4": "検知期間",
    "label5": "検知時間帯",
    "label6": "検知頻度",
    "text56": "通知メール送信先を入力してください",
    "text57": "通知メール送信先の形式が正しくありません"
  },
  "aiDetectionWeeklySchedule": {
    "label": "月",
    "label2": "火",
    "label3": "水",
    "label4": "木",
    "label5": "金",
    "label6": "土",
    "label7": "日",
    "text": "スケジュールが未設定です"
  },
  "llmText": {
    "shopliftingTargetLabel": "万引き対象",
    "shopliftingActionLabel": "万引き時の行動",
    "text11": "なし",
    "text12": "判定できません",
    "text13": "店舗の商品",
    "text14": "商品をバッグ・ポケット・衣服内へ移し、その後見えなくなる行動を確認しました。",
    "text15": "対象となる行動は確認されませんでした。",
    "text16": "映像だけでは商品と人物の動きを確認できませんでした（判定不可）。"
  }
}
